@if (formGroup) {
  <form [formGroup]="formGroup" class="grid grid-cols-2 gap-3">
    <em-select formControlName="operator" [subscriptSizing]="'dynamic'">
      <em-option [value]="null"> </em-option>
      @for (operator of operators; track $index) {
        <em-option [value]="operator.name">
          {{ 'G_FILTER_' + operator.name.toUpperCase() + '_VALUE' | translate }}
        </em-option>
      }
      <em-error>{{ 'SHARED_REQUIRED_FIELD' | translate }}</em-error>
    </em-select>

    @if (formGroup.get('operator')?.value === 'eq') {
      <em-select formControlName="value" [subscriptSizing]="'dynamic'">
        <em-option [value]="null"> </em-option>
        @for (value of valuesList; track $index) {
          <em-option [value]="value">
            {{ 'G_FILTER_' + value.toUpperCase() + '_VALUE' | translate }}
          </em-option>
        }
        <em-error>{{ 'SHARED_REQUIRED_FIELD' | translate }}</em-error>
      </em-select>
    }
  </form>
}
